import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../..//shared/services/dialog.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { DecimalPipe } from '@angular/common';
import { EnvService } from '../../../shared/services/env.service';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { KitchenStockItemService } from '../../../shared/services/kitchen-stock-item.service';
import { AddConsumptionItemsComponent } from '../add-consumption-items/add-consumption-items.component';

@Component({
  selector: 'ngx-consumtion',
  templateUrl: './consumtion.component.html',
  styleUrls: ['./consumtion.component.scss']
})
export class ConsumtionComponent implements OnInit {

  searchKey : string;
  isDark: boolean = false;
  btnHideId=[]
  itemCount:number;
  item : any[];
  filteredFinalList: any[]=[];
  statusCode: number;
  apiUrl: string;
  private _album:any[]  = [];

  constructor(private kitchenStockItemService : KitchenStockItemService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private decimalPipe: DecimalPipe,
              private env: EnvService,
              ) { 
                this.apiUrl = this.env.apiUrl;
              }

  ngOnInit() {
    this.getAllItems();

  }




  openAddOrderItemButtonClick(item:any){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = item;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";
    this.dialogService.openDialog(AddConsumptionItemsComponent,dialogConfig)
    .afterClosed().subscribe(res => {
      this.getAllItems();
    });  

   }

  
getAllItems(){
    this.kitchenStockItemService.getAll()
      .subscribe({
        next:(res)=>{
          this.item = res.map(obj => ({...obj, filled : false}));  
          this.filteredFinalList = this.item;       
        },
        error: (err)=>{
          if (err instanceof HttpErrorResponse) {
            if (err.status == 401) {
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      });
     
  }

   
  
     applyFilter(){
      this.filteredFinalList = this.item.filter((el)=>{
         return el.Name.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1
       });


     }
     onSearchClear(){
       this.searchKey = "";
       this.applyFilter();
     }

  

     savePDF(action:string){

      const documentDefinition:any = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Customer Outstanding Report', style: 'reportHeader' }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],  
                // body: [  
                //   ['InvoiceNo', 'InvoiceDate', 'Customer', 'PmtType', 'DueDate', 'Overdue', 'Status', 'InvoiceTotal', 'AmountPaid', 'Balance'],
                //   ...this.filteredFinalList.map(p => ([p.InvoiceNo, moment(p.InvoiceDate).format("YYYY-MM-DD"), p.CusName, p.PaymentType, (p.DueDate) ? moment(p.DueDate).format("YYYY-MM-DD") : '', (this.getDayDiffrence(p.InvoiceDate,p.PaymentType,p.Status)) ? this.getDayDiffrence(p.InvoiceDate,p.PaymentType,p.Status) : '' , p.Status, {text : this.transformNumberFormat(p.GrandTotal), alignment: 'right'  }, { text : this.transformNumberFormat(p.AmountPaid),alignment: 'right'  }, { text: this.transformNumberFormat(p.BalToPay),alignment: 'right' }])),  
                //   [ { text: 'Total balance due', bold: true, colSpan: 9 }, {},{},{},{},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotalBalance()),alignment: 'right', bold : true } ]  
                // ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
    
        // let element = document.getElementById('cusBalReport'); 
        // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 

        // const wb: XLSX.WorkBook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 

        // XLSX.writeFile(wb, 'Customer Outstanding Report.xlsx');
       
     }

     transformNumberFormat(number:any) {
         return this.decimalPipe.transform(number,'1.2-2');
      }




    }